import { Component, HostListener, inject, OnDestroy } from '@angular/core';
import { InactivityTimerService } from './services/inactivity-timer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnDestroy {
  title = 'Government ICT Services Portal';

  loadingRoute: boolean;
  private readonly inactivityTimerService: InactivityTimerService = inject(
    InactivityTimerService,
  );

  ngOnDestroy(): void {
    this.inactivityTimerService.resetTimer();
  }

  @HostListener('document:mousemove')
  @HostListener('document:click')
  @HostListener('document:keypress')
  refreshUserActivity(): void {
    this.inactivityTimerService.refreshUserActivity();
  }
}
